import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section aria-labelledby="kit-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-165" data-mp="2588vhoenuqz9">
      <Reveal className="mx-auto max-w-content" data-id="element-166" data-mp="25aljojb0hxkr">
        <div className="mb-12 text-center" data-id="element-167" data-mp="2a8da18w0dbmu">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-168" data-mp="2a4z8u3z2z8gz">
            TUTTO IN UN UNICO PACK
          </p>
          <h2 id="kit-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-169" data-mp="2j78lp0htndxj">
            📘 Cosa Contiene EDUCAZIONE FISICA PRONTA™?
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-170" data-mp="2sy35zzbic3gc">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-[18px] border border-brand-sand bg-brand-cream p-7 text-center" data-id="element-171" data-mp="2xyhc3btjt3bq">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-primary" strokeWidth={1.5} aria-hidden="true" data-id="element-172" data-mp="10mnkn96b5k1r" />
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-primary" data-id="element-173" data-mp="vlrl17szok25">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-174" data-mp="qo7up9j0ogtu">{description}</p>
            </article>)}
        </div>
        <div className="mt-10 flex justify-center" data-id="element-175" data-mp="mo7f3lk6lzl7">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-176" data-mp="1jb2c1xkjf033" />
        </div>
      </Reveal>
    </section>;
}